import Api from "../services/Api";



export const updtCompany = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/update', userData);

      console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};


export const addCompany = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/add', userData);

      console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};


export const getAllCompany = async () => {

    var res = {
      status: null
    }

    try {
      const response = await Api.get('/company/manage/all');

      console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const getCompanyData = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/info', userData);

      // console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const joinCompany = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/join', userData);

      // console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const addProduct = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/addProduct', userData);

      // console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};

export const updateProduct = async (userData) => {

    var res = {
      status: null
    }

    try {
      const response = await Api.post('/company/manage/updateProduct', userData);

      // console.log('response.results', response);
      res.status = "valid";

      res = {...res,...response};

      // console.log(res);

      return res;

    } catch (error) {

      res.status = "error";
      var errorData = error.response.data; 
      res = {...res,...errorData};
      return res;
    }
};